import React, { useState } from "react";
import "../my component/style.css";
import { sendEmail } from "./email.js";

const Section4 = () => {
  const [formData, setFormData] = useState({
    email: "",
    message: "",
    errorMessage: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      await sendEmail(formData.email, formData.message);
      setSubmitStatus("success");
      setFormData({ email: "", message: "", errorMessage: "" });
    } catch (error) {
      console.error("Error sending email:", error);
      setSubmitStatus("error");
      // Store the specific error message for display
      setFormData((prevState) => ({
        ...prevState,
        errorMessage: error.message,
      }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section4">
      <div className="section4-container">
        <div className="section4-content">
          <h2 className="section4-title">Get In Touch</h2>
          <p className="section4-subtitle">
            Have a question or want to work together? Send me a message!
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="form-input"
                placeholder="your.email@example.com"
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">
                Message (minimum 10 characters)
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="form-textarea"
                placeholder="Your message here... (minimum 10 characters)"
                rows="5"
                minLength="10"
                maxLength="1000"
                required
                disabled={isSubmitting}
              />
            </div>

            <button
              type="submit"
              className="send-button"
              disabled={isSubmitting}
              aria-label={isSubmitting ? "Sending message..." : "Send message"}
            >
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>

            {submitStatus === "success" && (
              <div className="success-message">
                Message sent successfully! I'll get back to you soon.
              </div>
            )}

            {submitStatus === "error" && (
              <div className="error-message" style={{ whiteSpace: "pre-line" }}>
                {formData.errorMessage ||
                  "Failed to send message. Please try again."}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Section4;